import { useEffect, useState } from "react";
import api, { fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader, Loader } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Landmark, ArrowRight } from "lucide-react";

export default function VatDeclaration() {
  const [periods, setPeriods] = useState([]);
  const [pid, setPid] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [draft, setDraft] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/accounting/periods").then((r) => { setPeriods(r.data); const a = r.data.find((x) => x.active) || r.data[0]; if (a) { setPid(a.id); setStart(a.date_debut); setEnd(a.date_fin); } }).catch(() => {});
  }, []);
  const compute = () => api.get("/accounting/reports/vat", { params: { period_id: pid, start, end, include_draft: draft } }).then((r) => setData(r.data));
  useEffect(() => { if (pid) compute(); }, [pid, start, end, draft]);

  return (
    <div>
      <PageHeader title="Déclaration de TVA" subtitle="TVA collectée − TVA déductible = montant à reverser à l'État" />

      <div className="rounded-xl border bg-white p-4 mb-4 flex flex-wrap items-end gap-3">
        <div><label className="text-[11px] uppercase text-slate-400">Exercice</label>
          <Select value={pid} onValueChange={setPid}><SelectTrigger className="w-52 mt-1" data-testid="vat-period"><SelectValue /></SelectTrigger>
            <SelectContent>{periods.map((p) => <SelectItem key={p.id} value={p.id}>{p.libelle}</SelectItem>)}</SelectContent></Select></div>
        <div><label className="text-[11px] uppercase text-slate-400">Du</label><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="mt-1" data-testid="vat-start" /></div>
        <div><label className="text-[11px] uppercase text-slate-400">Au</label><Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="mt-1" data-testid="vat-end" /></div>
        <label className="flex items-center gap-2 text-sm text-slate-500"><input type="checkbox" checked={draft} onChange={(e) => setDraft(e.target.checked)} data-testid="vat-draft" />Inclure brouillons</label>
      </div>

      {!data ? <Loader /> : (
        <div className="max-w-2xl">
          <div className="rounded-xl border bg-white divide-y" data-testid="vat-result">
            <div className="flex items-center justify-between p-4"><div className="flex items-center gap-2 text-slate-600"><Landmark className="h-4 w-4 text-emerald-600" />TVA collectée (compte 443)</div><span className="font-mono font-semibold text-emerald-700">{fmtMoney(data.tva_collectee)}</span></div>
            <div className="flex items-center justify-between p-4"><div className="flex items-center gap-2 text-slate-600"><Landmark className="h-4 w-4 text-amber-600" />TVA déductible (compte 445)</div><span className="font-mono font-semibold text-amber-700">− {fmtMoney(data.tva_deductible)}</span></div>
            <div className="flex items-center justify-between p-4 bg-brand-50/40">
              <div className="flex items-center gap-2 font-head font-semibold"><ArrowRight className="h-4 w-4 text-brand-600" />{data.solde >= 0 ? "TVA à reverser à l'État" : "Crédit de TVA reportable"}</div>
              <span className={`font-mono font-bold text-lg ${data.solde >= 0 ? "text-brand-700" : "text-rose-700"}`} data-testid="vat-net">{fmtMoney(data.solde >= 0 ? data.a_reverser : data.credit_tva)}</span>
            </div>
          </div>
          <p className="mt-3 text-sm text-slate-400">Période : {fmtDate(data.start)} → {fmtDate(data.end)} · calculé sur {data.nb_ecritures} écriture(s){draft ? " (brouillons inclus)" : " validée(s)"}.</p>
        </div>
      )}
    </div>
  );
}
